class Footer {

  constructor() {
    this.initialize();
  }

  initialize() {
    $(document).ready(function() {
      $('[data-menu-footer-open]').on('click', function() {
        let el = $(this);
        let parent = el.parent();

        parent.toggleClass('open')
      });
    })
  }
}

new Footer();
